module.exports = __webpack_public_path__ + "static/media/hero-desktop.1ce5bce4.jpg";